/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */

import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

const TableSkeleton = () =>
{
    return <>
        <TableContainer>
            <Table size="medium" sx={{width: '100%', minWidth: 'inherit'}}>
                <TableBody>
                    <TableRow>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                        <StyledTableCell><Skeleton variant="rectangular" sx={{width: '100%', maxWidth: '90%'}} height={20} /></StyledTableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </>
}

export default TableSkeleton;

const StyledTableCell = styled(TableCell)(({}) => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));